import { createContext } from 'react';

type FeatureFlagContextType = Set<string>;

export const FeatureFlagContext = createContext<FeatureFlagContextType>(new Set(''));
